import axios from 'axios';
import base from './api.base';

const baseUrl = process.env.NODE_ENV === 'production' ? base.prod : base.dev;

axios.defaults.timeout = 10000;
axios.defaults.baseURL = baseUrl;

// TODO: 暂没有请求需要拦截
axios.interceptors.request.use(
  config => {
    return config; 
  },
  error => {
    return Promise.error(error);
  },
);

// TODO: 还不知道接口，暂不封装响应
axios.interceptors.response.use(
  response => {
    return Promise.resolve(response.data);
  },
  error => {
    return Promise.reject(error);
  },
);

export default axios;



// WEBPACK FOOTER //
// ./src/api/axios.config.js